module.exports = __webpack_public_path__ + "img/two-thin-arrows-forming-a-circle.1b901024.svg";